import * as React from 'react';
import { ReactNode } from 'react';
import { Toolbar } from 'primereact/toolbar';
import { TabPanel, TabView } from 'primereact/tabview';
import { Layout } from '../../../Layout';
import { IntlShape, useIntl } from 'react-intl';
import { Accordion } from 'primereact/accordion';

interface Props {
  tags?: ReactNode;
  title: ReactNode;
  header: ReactNode;
  toolbar: {
    left: ReactNode[];
    right: ReactNode[];
    center: ReactNode[];
  };
  details: ReactNode[];
  tabs: {
    title: ReactNode;
    content: ReactNode;
  }[];
}

export const DetailView = (props: Props): ReactNode => {
  const intl: IntlShape = useIntl();

  const left: ReactNode[] = props.toolbar.left.filter(Boolean);
  const right: ReactNode[] = props.toolbar.right.filter(Boolean);
  const center: ReactNode[] = props.toolbar.center.filter(Boolean);
  const details: ReactNode[] = props.details.filter(Boolean);

  return <Layout>
    <div className={'flex flex-column px-3 gap-2'}>
      {props.tags && <div className={'tags flex gap-1'}>{props.tags}</div>}
      <div><h1 className={'my-0 flex gap-1'}>{props.title}</h1></div>
      <div className={'flex flex-column gap-2'}>
        {props.header}
      </div>
    </div>
    {left.length + center.length + right.length > 0 && <Toolbar
      start={
        <div className={'flex gap-1'}>
          {left}
        </div>
      }
      center={center}
      end={
        <div className={'flex gap-1'}>
          {right}
        </div>
      }
    />}
    {props.tabs.length > 0 ? (
      <TabView scrollable={true}>
        <TabPanel header={intl.formatMessage({id: 'button.details'})}>
          <Accordion multiple={true} activeIndex={[...Array(details.length).keys()]}>
            {details}
          </Accordion>
        </TabPanel>
        {props.tabs.map((tab, index): ReactNode => {
          return (
            <TabPanel key={index} header={tab.title}>
              {tab.content}
            </TabPanel>
          );
        })}
      </TabView>
    ) : (
      <Accordion className={'mx-4'} multiple={true} activeIndex={[...Array(details.length).keys()]}>
        {details}
      </Accordion>
    )}
  </Layout>;
};

export default DetailView;
